<template>
  <div id="courses" class="invite">
    <div class="top">
      <h2>购课提成</h2>
      <p>邀请好友购买以下课程，获得提成收入</p>
    </div>
    <div class="course-list" v-for="(item, index) in rule.list" :key="index">
      <div v-for="course in item.course" :key="course.course_id">
        <h3>{{ course.title }}</h3>
        <div class="course-item">
          <div class="top">
            <div class="ratio">
              <div class="ratio-item" :class="{ active: isBasicIncome }">
                <i v-if="isBasicIncome" class="anyteachicon anyteach-check-circle" />
                <h1>
                  <span>{{ item.basic_ratio | percentage }}</span>
                </h1>
                <h2 v-if="hasBasicIncome">基础收入</h2>
                <h2 v-else>提成收入</h2>
              </div>
              <div v-if="hasBasicIncome" class="ratio-item" :class="{ active: !isBasicIncome }">
                <i v-if="!isBasicIncome" class="anyteachicon anyteach-check-circle" />
                <h1>
                  <span>{{ item.excess_ratio | percentage }}</span>
                </h1>
                <h2>超额收入</h2>
              </div>
            </div>
            <div class="img" :style="$bgd(course.img)" />
          </div>
          <div class="middle">
            <div class="event">
              <div class="header">有效课程</div>
              <div class="header">价格</div>
            </div>
            <div class="event" v-for="event in course.event" :key="event.event_id">
              <div class="left">{{ event.event_title }}</div>
              <div class="right">{{ event.price | price }}</div>
            </div>
          </div>
          <router-link
            tag="div"
            class="bottom red"
            :to="'/courses/' + course.course_id + '?showShare=1'"
          >
            <i class="anyteachicon anyteach-ArtboardCopy" />点击前往分享
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { percentage, price } from "./utils"
export default {
  name: "courses",
  props: ["list", "rule"],
  filters: { percentage, price },
  computed: {
    hasBasicIncome() {
      return this.rule.basic_income > 0
    },
    isBasicIncome() {
      return !this.hasBasicIncome || this.rule.total_income < this.rule.basic_income
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";

.course-list {
  .course-item {
    margin-bottom: 15px;
    @include card();
    &:not(:last-child) {
      margin-bottom: 15px;
    }
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;

      .ratio {
        .ratio-item {
          display: inline-block;
          text-align: left;
          opacity: 0.3;
          margin-right: 5px;
          position: relative;
          i {
            position: absolute;
            top: -3px;
            right: -3px;
            font-size: 12px;
          }
          h1 {
            font-size: 1.5rem;
            padding-bottom: 3px;
            margin: 0;
          }
          h2 {
            font-size: 0.8rem;
            font-weight: 400;
            margin: 0;
          }
        }
        .active {
          opacity: 1;
          h1,
          i {
            color: $red;
          }
        }
      }
    }
    .middle {
      padding: 0 10px 10px 10px;
      font-size: 0.85rem;
      .event {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 1.4;
        &:first-child {
          line-height: 1.2;
        }
        &:last-child {
          padding-bottom: 0;
        }
        .header {
          opacity: 0.6;
        }
        .left,
        .right {
          font-weight: 500;
        }
        .left {
          .event-price {
            display: block;
            opacity: 0.6;
          }
        }
        .right {
          font-size: 0.9rem;
          @include avenir-demi();
        }
      }
    }
    .bottom {
      font-size: 0.85rem;
      font-weight: 500;
      border-top: 1px solid #eee;
      padding: 8px 10px;
      &:active {
        opacity: 0.6;
      }
      i {
        font-size: inherit;
        margin: 0 3px 0 0;
      }
    }
    .img {
      min-width: 96px;
      min-height: 60px;
      border-radius: 4px;
      background-color: #eee;
      border: 1px solid #eee;
      background-position: center;
      background-size: cover;
    }
    @media only screen and (max-width: 320px) {
      img {
        min-width: 144px;
        min-height: 90px;
      }
    }
    h1 {
      font-size: 1rem;
      @include avenir-demi();
      line-height: 1.2;
      margin: 0;
    }
    p {
      padding-bottom: 3px;
      font-size: 0.9rem;
    }
    p.red {
      @include avenir-demi();
    }
  }
}
</style>
